import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.CHECKUP_ENDPOINT
})

instance.defaults.headers.common['Content-Type'] = 'application/json'

export default instance



// WEBPACK FOOTER //
// ./src/config/axios-check-up.js